<div class="header pb-6 d-flex align-items-center" style="min-height: 500px; background-image: url(../../assets/img/theme/profile-cover.jpg); background-size: cover; background-position: center top;">
  <!-- Mask -->
  <span class="mask bg-gradient-default opacity-8"></span>
  <!-- Header container -->
  <div class="container-fluid d-flex align-items-center">
    <div class="row">
      <div class="col-lg-7 col-md-10">
        <h1 class="display-4 text-white">Hello {{ currentUser.full_name }}</h1>
        <p class="text-white mt-0 mb-5">This is your profile page. You can make modification by clicking the Edit Button below.</p>
        <a href="javascript:void(0)" (click)="initEdit()" *ngIf="!isEditProfile" class="btn btn-neutral">Edit profile</a>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt--6">
  <div class="row">
    <div class="col-xl-4 order-xl-2">
      <div class="card card-profile">
        <img src="../../assets/img/theme/img-1-1000x600.jpg" alt="Image placeholder" class="card-img-top">
        <div class="row justify-content-center pb-4">
          <div class="col-lg-3 order-lg-2">
            <div class="card-profile-image">
              <a href="javascript:void(0)">
                <img [src]="currentUser.profile_picture ? currentUser.profile_picture : '../../assets/img/user-img.jpg'" class="rounded-circle">
              </a>
            </div>
          </div>
        </div>
        <div class="card-body pt-5">
          <div class="text-center">
            <h5 class="h3">
              {{ currentUser.full_name }}<span class="font-weight-light"></span>
            </h5>
            <div class="h5 font-weight-300">
              <i class="ni location_pin mr-2"></i>{{ currentUser.email }}
            </div>
            <div class="h5 font-weight-300" *ngIf="currentUser.phone_number">
              <i class="ni location_pin mr-2"></i>{{currentUser.phone_number }}
            </div>
            <div class="h5 mt-4">
              <i class="ni business_briefcase-24 mr-2"></i>Role - {{currentUser.role | titlecase }}
            </div>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="currentUser.privileges?.length > 0">
        <!-- Card header -->
        <div class="card-header">
          <!-- Title -->
          <h5 class="h3 mb-0">Privileges</h5>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <!-- List group -->
          <ul class="list-group list-group-flush list my--3">

            <li class="list-group-item px-0" *ngFor="let privilege of currentUser.privileges">
              <div class="row align-items-center">
                <div class="col-auto">
                  <!-- Avatar -->
                  <span class="avatar rounded-circle" *ngIf="privilege === 'CHIEF_ADMIN'">
                    <i class="fa fa-unlock"></i>
                  </span>
                  <span class="avatar rounded-circle" *ngIf="privilege === 'UPLOADER'">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="avatar rounded-circle" *ngIf="privilege === 'VERIFIER1'">
                    <i class="fa fa-check"></i>
                  </span>
                  <span class="avatar rounded-circle" *ngIf="privilege === 'VERIFIER2'">
                    <i class="fa fa-check-circle"></i>
                  </span>
                </div>
                <div class="col">
                  <h5>{{privilege.split('_').join(' ')}}</h5>
                  <div class="progress progress-xs mb-0">
                    <div class="progress-bar bg-green" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%;"></div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-xl-8 order-xl-1">
      <div class="card">
        <div class="card-header" *ngIf="isEditProfile">
          <div class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Edit profile </h3>
            </div>

          </div>
        </div>
        <div class="card-body">
            <h6 class="heading-small text-muted mb-4">User information</h6>
            <form novalidate (ngSubmit)="updateProfile()">
              <div class="pl-lg-4">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="form-control-label" for="input-username">Full Name</label>
                      <input type="text" id="input-username" class="form-control" placeholder="Full Name"
                             [disabled]="!isEditProfile" [(ngModel)]="cloneCurrentUser.full_name"
                             [ngModelOptions]="{standalone: true}">
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="form-control-label" for="input-email">Email address</label>
                      <input type="email" id="input-email" class="form-control" placeholder="Email Address"
                             [disabled]="!isEditProfile" [(ngModel)]="cloneCurrentUser.email"
                             [ngModelOptions]="{standalone: true}">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="form-control-label" for="input-first-name">Phone Number</label>
                      <input type="text" id="input-first-name" class="form-control" [disabled]="!isEditProfile"
                             placeholder="Phone Number" [(ngModel)]="cloneCurrentUser.phone_number"
                             [ngModelOptions]="{standalone: true}">
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label class="form-control-label" for="input-last-name">Role</label>
                      <input type="text" id="input-last-name" class="form-control" disabled readonly placeholder="Role"
                             [value]="cloneCurrentUser.role">
                    </div>
                  </div>
                </div>
                <div class="row text-center">
                  <div class="col-12">
                    <button class="btn btn-primary" type="submit" [disabled]="!isEditProfile" *ngIf="!isUpdating">Update Profile</button>
                    <button class="btn btn-primary" type="button" [disabled]="true" *ngIf="isUpdating"><i class="fa fa-spin fa-spinner"></i></button>
                  </div>
                </div>
              </div>
            </form>
        </div>
      </div>
    </div>
  </div>
</div>
